export default "__VITE_ASSET__UGHHb57X__"